import { axios } from '@/lib/axios';

import { CashoutInput } from '../components/CashoutForm';

// export const getTransactions = async () => {
//   const resp = await axios.get(`/transactions?pageSize=5000`);
//   return resp.data;
// };

export const getTransactions = async (filters?: {
  type?: string;
  status?: string;
  user?: string;
}) => {
  const params: any = { pageSize: 5000 };

  if (filters?.type) params.type = filters.type;
  if (filters?.status) params.status = filters.status;
  if (filters?.user) params.user = filters.user;

  const resp = await axios.get('/transactions', { params });
  return resp.data;
};

export const getTransactionsStat = async () => {
  const resp = await axios.get(`/transactions/type/stat`);
  return resp.data;
};

export const getCashout = async (filters?: {
  pageSize?: number;
  startDate?: string;
  endDate?: string;
}) => {
  const params: any = { pageSize: filters?.pageSize ?? 20 };
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;

  const resp = await axios.get(`/wallets/cashout/all`, { params });
  return resp.data;
};

export const paidCashout = async ({
  cashoutID,
  payload,
}: {
  cashoutID: string;
  payload: CashoutInput;
}) => {
  const resp = await axios.patch(`/wallets/cashout/${cashoutID}/paid`, payload);
  return resp.data;
};

export const cancelCashout = async (_id: string) => {
  const resp = await axios.patch(`/wallets/cashout/${_id}/cancel`, {
    cancelationReason: 'not eligible',
  });
  return resp.data;
};
